export default __webpack_public_path__ + "static/typography-image-d-9a05f317a34e1cdaa929ea1feee963ce5b122bb2f3b965f869202be7ab95d3c4.png";